
import React, { useEffect, useState } from 'react';
import NonFSIndex from "@dndComponents/NonFSIndex";
import { 
  FeatureSource, 
  ModelBase, 
  OptionalFeatureBase, 
  PlayerObject 
} from "@models";
import { Creature, Transform } from "@dndModels";
import { FEATURE_SOURCE_TYPES } from "@dndModels/Constants";

import DandDAPI from "@dndUtilities/system_api";
import LoadingBox from "@components/input/LoadingBox";

const api = DandDAPI.getInstance();

export default function FloatingFeatureIndex() {
  const [fetched, setFetched] = useState(false);
  const [loading, setLoading] = useState(false);
  const [creatures, setCreatures] = useState<Creature[]>([]);
  const [transforms, setTransforms] = useState<Transform[]>([]);
  const [ofbs, setOFBs] = useState<OptionalFeatureBase[]>([]);

  // eslint-disable-next-line
  useEffect(() => {
    if (!fetched) {
      setFetched(true);
      setLoading(true);
      api.getSetOfObjects({ data_types: [...FEATURE_SOURCE_TYPES,"creature","transform","optional_feature_base"] }).then(res => {
        setCreatures(res.creature as Creature[]);
        setTransforms(res.transform as Transform[]);
        setOFBs(res.optional_feature_base as OptionalFeatureBase[]);
        setLoading(false);
      });
    }
  });

  if (!fetched || loading) {
    return (<div className="centered"><LoadingBox size={window.innerHeight * 0.5} height={window.innerHeight - 81} /></div>);
  } else {
    return (
      <NonFSIndex
        data_type="floating_feature"
        save_all
        // extra_filter={(obj: ModelBase | PlayerObject) => {
        //   if (obj instanceof BonusSpells && obj.spells.length > 1 && obj.spells.filter(o => o.level > 1).length === 0) {
        //     return true;
        //   }
        //   return false;
        // }}
        // extra_filter={(obj: ModelBase | PlayerObject) => {
          
        //   for (const fs_type of FEATURE_SOURCE_TYPES) {
        //     if (api.smart_hash[fs_type]) {
        //       console.log(fs_type);
        //       const fs = (api.smart_hash[fs_type] as FeatureSource[]).find(o => o.feature_bases.filter(o2 => o2.features.filter(o3 => o3.floating_feature_id === obj._id).length > 0).length > 0);
        //       if (fs) {
        //         return false;
        //       }
        //     }
        //   }
        //   const ofb = ofbs.find(o => 
        //     o.features.find(o3 => o3.floating_feature_id === obj._id)
        //   );
        //   if (ofb) {
        //     return false;
        //   }
        //   const transform = transforms.find(o => o.features.find(o3 => o3.floating_feature_id === obj._id));
        //   if (transform) {
        //     return false;
        //   }
        //   const creature = creatures.find(o => o.fbs.find(o2 => o2.features.find(o3 => o3.floating_feature_id === obj._id)));
        //   if (creature) {
        //     return false;
        //   }
        //   return true;
        // }}
        extra={(obj: ModelBase | PlayerObject) => {
          // if (obj instanceof Modifier) {
            // Identify a thing that has it
            for (const fs_type of FEATURE_SOURCE_TYPES) {
              if (api.smart_hash[fs_type]) {
                console.log(fs_type);
                const fs = (api.smart_hash[fs_type] as FeatureSource[]).find(o => o.feature_bases.filter(o2 => o2.features.filter(o3 => o3.floating_feature_id === obj._id).length > 0).length > 0);
                if (fs) {
                  return <>In {fs_type}: {fs.true_name}</>;
                }
              }
            }
            const ofb = ofbs.find(o => 
              o.features.find(o3 => o3.floating_feature_id === obj._id)
            );
            if (ofb) {
              return <>In Optional Feature: {ofb.true_name}</>;
            }
            const transform = transforms.find(o => o.features.find(o3 => o3.floating_feature_id === obj._id));
            if (transform) {
              return <>In Transform: {transform.true_name}</>;
            }
            const creature = creatures.find(o => o.fbs.find(o2 => o2.features.find(o3 => o3.floating_feature_id === obj._id)));
            if (creature) {
              return <>In Creature: {creature.true_name}</>;
            }
          // }
          return <></>;
        }}
        // save_all
        // display_format="{obj.true_name}"
      />
    );
  }
}
